/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FeedbackOverviewRequest,
  FeedbackOverviewUi,
  MessageFeedbackTableRequest,
  MessageFeedbackTableResponse,
  SurveyTableRequest,
  SurveyTableResponse,
} from '../models';

export interface GetFeedbackOverviewRequest {
    feedbackOverviewRequest: FeedbackOverviewRequest;
}

export interface GetMessageFeedbackTableRequest {
    messageFeedbackTableRequest: MessageFeedbackTableRequest;
}

export interface GetSurveyTableRequest {
    surveyTableRequest: SurveyTableRequest;
}

/**
 * 
 */
export class FeedbackApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async getFeedbackOverviewRaw(requestParameters: GetFeedbackOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeedbackOverviewUi>> {
        if (requestParameters['feedbackOverviewRequest'] == null) {
            throw new runtime.RequiredError(
                'feedbackOverviewRequest',
                'Required parameter "feedbackOverviewRequest" was null or undefined when calling getFeedbackOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/feedback/overview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['feedbackOverviewRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getFeedbackOverview(requestParameters: GetFeedbackOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeedbackOverviewUi> {
        const response = await this.getFeedbackOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMessageFeedbackTableRaw(requestParameters: GetMessageFeedbackTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageFeedbackTableResponse>> {
        if (requestParameters['messageFeedbackTableRequest'] == null) {
            throw new runtime.RequiredError(
                'messageFeedbackTableRequest',
                'Required parameter "messageFeedbackTableRequest" was null or undefined when calling getMessageFeedbackTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/feedback/messages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['messageFeedbackTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getMessageFeedbackTable(requestParameters: GetMessageFeedbackTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageFeedbackTableResponse> {
        const response = await this.getMessageFeedbackTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSurveyTableRaw(requestParameters: GetSurveyTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SurveyTableResponse>> {
        if (requestParameters['surveyTableRequest'] == null) {
            throw new runtime.RequiredError(
                'surveyTableRequest',
                'Required parameter "surveyTableRequest" was null or undefined when calling getSurveyTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/feedback/surveys`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['surveyTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSurveyTable(requestParameters: GetSurveyTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SurveyTableResponse> {
        const response = await this.getSurveyTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
